import request from '@/utils/request';


export function getShopModuleList(query) {
  return request({
    url: '/api/system/shopModule/queryShopModuleList',
    method: 'post',
    data: query
  });
}

export function getShopModule(query) {
  return request({
    url: '/api/system/shopModule/getShopModule',
    method: 'post',
    data: query
  });
}



// WEBPACK FOOTER //
// ./src/api/module/index.js